import type { ProjectBriefSource } from "../types/projectBrief";

export type ParsedSourceRef =
  | { kind: "meeting"; id: string }
  | { kind: "document"; id: string }
  | { kind: "unknown"; raw: string };

export function parseSourceId(source: ProjectBriefSource): ParsedSourceRef {
  if (typeof source === "object") {
    if ((source as any)?.type === "MEETING" && typeof (source as any).id === "string") {
      return { kind: "meeting", id: (source as any).id };
    }

    if ((source as any)?.type === "DOCUMENT" && typeof (source as any).id === "string") {
      return { kind: "document", id: (source as any).id };
    }
  }

  const trimmed = (source as string).trim();

  if (trimmed.startsWith("meeting:")) {
    return { kind: "meeting", id: trimmed.slice("meeting:".length) };
  }

  if (trimmed.startsWith("doc:") || trimmed.startsWith("document:")) {
    const prefix = trimmed.startsWith("doc:") ? "doc:" : "document:";
    return { kind: "document", id: trimmed.slice(prefix.length) };
  }

  return { kind: "unknown", raw: trimmed };
}
